import type {
  PortfolioSection,
  PortfolioType,
} from "@/dashboard/inventory_management/portfolios/types";

export interface PortfolioTypeConfig {
  icon: string;
  iconColorClass: string;
  borderClass: string;
  section: PortfolioSection;
  badgeClass: string;
  renameable: boolean;
  splittable: boolean;
  mergeable: boolean;
  moveable: boolean;
  allowedMoveTargets: PortfolioType[];
  linkLabel?: string;
}

export const PORTFOLIO_TYPE_CONFIG: {
  [K in PortfolioType]?: PortfolioTypeConfig;
} = {
  HOLD: {
    icon: "fas fa-building",
    iconColorClass: "text-self-managed",
    borderClass: "border-self-managed",
    section: "inventory",
    badgeClass: "bg-self-managed-subtle text-self-managed-emphasis",
    renameable: true,
    splittable: true,
    mergeable: true,
    moveable: false,
    allowedMoveTargets: [],
  },
  VIRTUAL: {
    icon: "fas fa-cloud-upload-alt",
    iconColorClass: "text-self-managed",
    borderClass: "border-self-managed",
    section: "inventory",
    badgeClass: "bg-self-managed-subtle text-self-managed-emphasis",
    renameable: true,
    splittable: true,
    mergeable: true,
    moveable: false,
    allowedMoveTargets: [],
  },
  OWN_USE: {
    icon: "fas fa-ban",
    iconColorClass: "text-secondary",
    borderClass: "border-secondary",
    section: "inventory",
    badgeClass: "bg-secondary-subtle text-secondary-emphasis",
    renameable: false,
    splittable: false,
    mergeable: false,
    moveable: false,
    allowedMoveTargets: [],
  },
  SPOT_MARKET_PRICE: {
    icon: "fas fa-chart-line",
    iconColorClass: "text-spot",
    borderClass: "border-spot",
    section: "spot",
    badgeClass: "bg-spot-subtle text-spot-emphasis",
    renameable: false,
    splittable: false,
    mergeable: false,
    moveable: true,
    allowedMoveTargets: ["SPOT_MIN_PRICE"],
  },
  SPOT_MIN_PRICE: {
    icon: "fas fa-lock",
    iconColorClass: "text-spot",
    borderClass: "border-spot",
    section: "spot",
    badgeClass: "bg-spot-subtle text-spot-emphasis",
    renameable: false,
    splittable: false,
    mergeable: false,
    moveable: true,
    allowedMoveTargets: ["SPOT_MARKET_PRICE"],
  },
  SPOT_STX: {
    icon: "fas fa-exchange-alt",
    iconColorClass: "text-spot",
    borderClass: "border-spot",
    section: "spot",
    badgeClass: "bg-spot-subtle text-spot-emphasis",
    renameable: false,
    splittable: false,
    mergeable: false,
    moveable: false,
    allowedMoveTargets: [],
  },
  PPA: {
    icon: "fas fa-file-contract",
    iconColorClass: "text-success",
    borderClass: "border-success",
    section: "ppa",
    badgeClass: "bg-success-subtle text-success-emphasis",
    renameable: true,
    splittable: false,
    mergeable: false,
    moveable: false,
    allowedMoveTargets: [],
    linkLabel: "portfolios.view_ppa_config",
  },
  FORWARD: {
    icon: "fas fa-calendar-alt",
    iconColorClass: "text-primary",
    borderClass: "border-primary",
    section: "forwards",
    badgeClass: "bg-primary-subtle text-primary-emphasis",
    renameable: false,
    splittable: false,
    mergeable: false,
    moveable: false,
    allowedMoveTargets: [],
    linkLabel: "portfolios.view_forwards",
  },
};

export interface PortfolioSectionConfig {
  id: PortfolioSection;
  titleKey: string;
  descriptionKey: string;
  volumeLabelKey: string;
  headerLinkLabel?: string;
  headerLinkRoute?: string;
  alwaysShow?: boolean;
  emptyMessageKey?: string;
}

export const PORTFOLIO_SECTIONS: PortfolioSectionConfig[] = [
  {
    id: "inventory",
    titleKey: "portfolios.section_inventory",
    descriptionKey: "portfolios.section_inventory_desc",
    volumeLabelKey: "portfolios.volume_label_inventory",
    alwaysShow: true,
    emptyMessageKey: "portfolios.empty_inventory",
  },
  {
    id: "spot",
    titleKey: "portfolios.section_spot",
    descriptionKey: "portfolios.section_spot_desc",
    volumeLabelKey: "portfolios.volume_label_spot",
  },
  {
    id: "ppa",
    titleKey: "portfolios.section_ppa",
    descriptionKey: "portfolios.section_ppa_desc",
    volumeLabelKey: "portfolios.volume_label_ppa",
  },
  {
    id: "forwards",
    titleKey: "portfolios.section_forwards",
    descriptionKey: "portfolios.section_forwards_desc",
    volumeLabelKey: "portfolios.volume_label_forwards",
  },
];
